import { Proto } from "../../../pojo/Proto";

//https://knowledge25.knowledgeowl.com/help/contactsxml-contact-listption
//https://knowledge25.knowledgeowl.com/help/series25-subscriber-sets
export namespace ContactSubscription {
    export type FilterParams = {
        name?: string; //

        first_name?: string;
        last_name?: string;

        range_start?: string;
        range_end?: string;
        email?: string;
        favorite?: string;
        organization_id?: number;
        contact_id?: string; // Format: "1+2+3+4+5" (IDs joined with "+")
        internal_id?: string;
        modified_since?: Proto.ISODateString;
        modified_since_duration?: string; //need to test the format
        attribute_id?: number;
        attribute_value?: string;
        //need testing
        group_id?: string; // Format: "1+2+3+4+5" (IDs joined with "+")
        not_attribute_id?: number;

        //todo: add keyword, starts_with, ends_with
        /*
        keyword?: string;
        starts_with?: string;
        ends_with?: string;
        */
    };

    /**
     * Const object that satisfies FilterParams type - used to extract keys at runtime
     * TypeScript ensures this object contains all keys from FilterParams
     */
    const FILTER_PARAMS_KEYS_OBJ = {
        name: true,
        first_name: true,
        last_name: true,
        range_start: true,
        range_end: true,
        email: true,
        favorite: true,
        organization_id: true,
        contact_id: true,
        internal_id: true,
        modified_since: true,
        modified_since_duration: true,
        attribute_id: true,
        attribute_value: true,
        group_id: true,
        not_attribute_id: true,
    } satisfies Record<keyof FilterParams, true>;

    /**
     * Array of all valid FilterParams keys extracted from the type
     * TypeScript ensures this stays in sync with the FilterParams type
     */
    export const VALID_FILTER_PARAM_KEYS = Object.keys(FILTER_PARAMS_KEYS_OBJ) as readonly (keyof FilterParams)[];
}
